export default __webpack_public_path__ + "static/media/acm_banner_image.fa108aa7.png";